import PropTypes from 'prop-types';
import React, { useContext } from 'react';

import AgentMetadata from './metadata/agent_metadata';
import ApiMetadata from './metadata/api_metadata';
import AutomatedMetadata from './metadata/automated_metadata';
import Communicator from 'models/communicator';
import ConversationItem from 'models/conversation_item';
import CustomerMetadata from './metadata/customer_metadata';
import ItemsContext from './items_context';
import SystemMetadata from './metadata/system_metadata';
import ThirdPartyMetadata from './metadata/third_party_metadata';

export default function ItemMetadata(props) {
  const { item, showMetadata } = props;
  const { detailedDatesEnabled } = useContext(ItemsContext);

  // Stacking normally hides metadata on same-sender continuations. With the "Detailed dates"
  // preference on, keep the timestamp on every message (only the avatar stays suppressed).
  if (!showMetadata && !detailedDatesEnabled) {
    return null;
  }

  switch (item.initiator.type) {
    case Communicator.AGENT:
      return <AgentMetadata {...props} />;
    case Communicator.API:
      return <ApiMetadata {...props} />;
    case Communicator.AUTOMATED:
      return <AutomatedMetadata {...props} />;
    case Communicator.CUSTOMER:
      return <CustomerMetadata {...props} />;
    case Communicator.EXTERNAL:
    case Communicator.INTERNAL:
      return <ThirdPartyMetadata {...props} />;
    case Communicator.SYSTEM:
    case Communicator.DEFAULT:
      return <SystemMetadata {...props} />;
    default:
      return null;
  }
}

ItemMetadata.defaultProps = {
  showMetadata: true,
  isTranslating: false,
};

ItemMetadata.propTypes = {
  item: PropTypes.instanceOf(ConversationItem).isRequired,
  showMetadata: PropTypes.bool,
  isTranslating: PropTypes.bool,
};
